export default __webpack_public_path__ + "static/media/David-Peters.36741fcd.png";